import { OidcClientSettings, UserManager } from 'oidc-client-ts';
import { getDevToken } from './DevAuth';

export const isDevMode = import.meta.env.VITE_USE_DEV_AUTH === 'true';

// Only validate environment variables if not in dev mode
if (!isDevMode) {
  const requiredEnvVars = {
    VITE_OIDC_AUTHORITY: import.meta.env.VITE_OIDC_AUTHORITY,
    VITE_API_URL: import.meta.env.VITE_API_URL,
    VITE_DEVICE_MANUFACTURING_API_URL: import.meta.env
      .VITE_DEVICE_MANUFACTURING_API_URL,
  };

  const missingVars = Object.entries(requiredEnvVars)
    .filter(([_, value]) => !value)
    .map(([key]) => key);

  if (missingVars.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missingVars.join(', ')}. ` +
        `Please configure these in AWS Amplify console under App settings → Environment variables.`,
    );
  }
}

export const EaseeClientOidcConfig: OidcClientSettings = {
  authority:
    import.meta.env.VITE_OIDC_AUTHORITY ||
    'https://auth.easee.com/realms/easee',
  client_id: 'easee-firmware-manager-portal',
  redirect_uri: `${window.location.origin}/login`,
};

export const OidcUserManager = new UserManager(EaseeClientOidcConfig);

export const getIdToken = async (): Promise<string> => {
  // In dev mode, use the manually provided token
  if (isDevMode) {
    return getDevToken();
  }

  // Otherwise use OIDC
  const user = await OidcUserManager.getUser();

  if (!user) {
    console.error('No authenticated user found');
  }

  return user?.access_token ?? '';
};
